/* KDD 15.10 : recalcule « dimanche JJ mois » du bandeau d'annonce à l'heure de
   Paris. Le Liquid de blocks/_announcement.liquid pose déjà la bonne date ; ce
   script ne sert que si la page a été servie depuis un cache d'avant minuit. */
(function () {
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
    'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function dimancheParis() {
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var jour = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(p.weekday) + 1;
    var d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day + (7 - jour)));
    return 'dimanche ' + (d.getUTCDate() === 1 ? '1er' : d.getUTCDate()) + ' ' + MOIS[d.getUTCMonth()];
  }

  function maj() {
    var texte;
    try { texte = dimancheParis(); } catch (e) { return; }
    document.querySelectorAll('[data-kdd-dimanche]').forEach(function (el) {
      if (el.textContent !== texte) el.textContent = texte;
    });
    var MC = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    var court = texte.replace('dimanche ', 'dim. ').replace(/ ([a-zéû]+)$/, function (m, mois) { return ' ' + MC[MOIS.indexOf(mois)]; });
    document.querySelectorAll('[data-kdd-dimanche-court]').forEach(function (el) {
      if (el.textContent !== court) el.textContent = court;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
})();
